import { Info } from "lucide-react";

// Shared field label: required asterisk + optional hover tooltip (native
// title attr) for the less-obvious ocean terms (CY, haulage mode, etc.) —
// used across Origin/Destination/Basic details instead of each repeating
// the same label markup.
const FieldLabel = ({ children, required, hint }) => (
  <label className="flex items-center gap-1 text-[11px] font-semibold text-gray-400 uppercase tracking-wide mb-1.5">
    <span>{children}</span>
    {required && <span style={{ color: "#E5484D" }}>*</span>}
    {hint && (
      <span title={hint} className="text-gray-300 hover:text-gray-500 cursor-help">
        <Info size={12} />
      </span>
    )}
  </label>
);

export default FieldLabel;
